export default {
	data() {
		return {
		}
	},
	methods: {
		updateDate(dateInfo) {
			this.entity[dateInfo.attrKey] = dateInfo.date
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/views/contentSourceMaintenanceWindow/mixins/contentSourceMaintenanceWindow.js